import React from 'react';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {FaDownload} from "react-icons/fa";

function CardDownloadProduct(props) {

    const {t, i18n} = useTranslation();

    const item = props.item;

    const dataFormat = (data) => {
        let _data = data.split('-');
        return _data[2] + '.' + _data[1] + '.' + _data[0];
    }

    return (
        <div className="col-md-3 p-2">
            <div className={'border rounded-4 p-2 d-flex align-items-center justify-content-between'}>
              <div className="d-flex align-items-center justify-content-start">
                  <div className="d-none- p-2">
                      <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/App_Store_%28iOS%29.svg/2048px-App_Store_%28iOS%29.svg.png" alt="logo_" className={'img-fluid'} width={'50px'}/>
                  </div>
                  <div className="title">
                      <h6 className={'text-dark'}>Name.app</h6>
                      <small className={'text-muted'}>123 MB</small>
                  </div>
              </div>
              <div className="link">
                  <Link to={''} target="_blank" download className={'nav-link p-2'}>
                      <FaDownload className={'text-dark'} />
                  </Link>
              </div>
            </div>
        </div>
    );
}

export default CardDownloadProduct;
